import {DEFAULT_PADDING} from '../map/map';

export function makeStaticMapUrl({
  center,
  height,
  markers,
  padding = DEFAULT_PADDING,
  polyline,
  style,
  token,
  width,
  zoom,
}: {
  center?: [number, number];
  height: number | string;
  markers?: string[];
  padding?: number;
  polyline?: string;
  style?: string;
  token: string;
  width: number | string;
  zoom?: number;
}) {
  const details = [];

  let stylePath = 'mapbox/streets-v11';
  if (style) {
    stylePath = style.replace('mapbox://styles/', '');
  }

  if (polyline) {
    details.push(polyline);
  }

  if (markers) {
    details.push(markers.join(','));
  }

  if (center) {
    details.push(center.join(','));
  }

  if (zoom) {
    details.push(zoom);
  }

  const paddingQuery = padding ? `&padding=${padding}` : '';
  const autoParam = polyline || markers ? '/auto' : '';

  return `https://api.mapbox.com/styles/v1/${stylePath}/static/${details.join(
    ','
  )}${autoParam}/${width}x${height}?access_token=${token}${paddingQuery}`;
}
